import React, { forwardRef } from 'react';
import InputContainer from '../InputContainer';
import { TextAreaProps, TRef } from './TextArea.types';

const TextArea = forwardRef(
  (
    {
      id,
      inputSize,
      error,
      success,
      label,
      iconLeft,
      iconRight,
      className,
      labelIcon,
      ...rest
    }: TextAreaProps,
    ref: TRef
  ) => {
    return (
      <InputContainer
        {...{
          inputSize,
          error,
          success,
          label,
          labelIcon,
          iconLeft,
          iconRight,
          className,
        }}
      >
        <textarea id={id} ref={ref} {...rest} />
      </InputContainer>
    );
  }
);

TextArea.displayName = 'TextArea';
export default TextArea;
